import { createSelector } from '@reduxjs/toolkit';
import { ERoomType } from '../../../../packages/JsonQuery';
import { selectRoomType } from 'shared/selectors/jsonQuery';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'Студия', value: ERoomType.Studio },
  { label: '1', value: ERoomType.FlatOneRoom },
  { label: '2', value: ERoomType.FlatTwoRooms },
  { label: '3', value: ERoomType.FlatThreeRooms },
  { label: '4', value: ERoomType.FlatFourRooms },
  { label: '5', value: ERoomType.FlatFiveRooms },
  { label: '6+', value: ERoomType.FlatManyRooms },
  { label: 'Свободная планировка', value: ERoomType.FlatFreeLayout },
];

export const selectRoomTypeFilter = createSelector(selectRoomType, value => ({
  value: value?.length ? (value as ERoomType[]) : [null],
  options: OPTIONS,
}));
